<template>
  <main class="admin__main">
    <card class="admin__aside" title="Панель администратора">
      <ul class="nav flex-column nav-pills">
        <li v-for="tab in tabs" class="nav-item">
          <router-link :to="{ name: tab.route, params: tab.params }" class="nav-link" active-class="active">
            <fa :icon="tab.icon" fixed-width/>
            {{ tab.name }}
          </router-link>
        </li>
      </ul>
    </card>
    <div class="admin__content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </main>
</template>

<script>
  import { mapGetters } from 'vuex';
  import RoutingService from '../../services/routing';

  export default {
    components: {
    },
    layout: 'admin',
    metaInfo () {
      return { title: 'Панель администратора' }
    },

    computed: {
      ...mapGetters({
        user: 'auth/user',
        userRole: 'auth/role',
      }),
      tabs () {
        const tabs = [];

        tabs.push({
          icon: 'book',
          name: 'Курсы',
          route: 'admin.courses',
          params: {}
        });
        tabs.push({
          icon: 'user',
          name: 'Пользователи',
          route: 'admin.users',
          params: {}
        });

        if (this.user.roles.indexOf('admin') !== -1) {
          tabs.push({
            icon: 'user',
            name: this.$t('admin.pages.partners.labels.title'),
            route: 'admin.partners',
            params: {}
          });

          tabs.push({
            icon: 'edit',
            name: this.$t('admin.pages.main.labels.title'),
            route: 'admin.pages.main',
            params: {}
          });

          tabs.push({
            icon: 'edit',
            name: this.$t('admin.pages.agreement.labels.title'),
            route: 'admin.pages.agreement',
            params: {}
          });

          tabs.push({
            icon: 'edit',
            name: 'Cookies',
            route: 'admin.pages.cookies',
            params: {}
          });

          tabs.push({
            icon: 'edit',
            name: 'Support',
            route: 'admin.pages.support',
            params: {}
          });

          tabs.push({
            icon: 'edit',
            name: this.$t('admin.pages.faq.labels.title'),
            route: 'admin.pages.faq',
            params: {}
          });

          tabs.push({
            icon: 'edit',
            name: this.$t('admin.pages.partnership.labels.title'),
            route: 'admin.pages.partnership',
            params: {}
          });
        }

        return tabs;
      }
    },
    beforeMount () {
    }
  }
</script>
